import React from 'react';
import styled from 'styled-components';
import Searchbar from './Searchbar';
import ManageUsersContext from '../ManageUsersContext';
import { StyledHeaderActions } from '../StyledComponents';

const TransfersHeader: React.FC<{ md: boolean }> = ({ md }) => {
  const { searchText, setSearchText } = React.useContext(ManageUsersContext);

  return (
    <StyledHeaderActions $md={md}>
      <StyledSearchbar
        value={searchText}
        onChange={e => setSearchText(e.target.value)}
        data-cy="transfers-search-input"
      />
    </StyledHeaderActions>
  );
};

const StyledSearchbar = styled(Searchbar)`
  margin-right: 8px;
`;

export default TransfersHeader;
